import { Button, Card, Popover } from '@blueprintjs/core'
import React, { useRef } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../../helper/classes'
import { OverlayProps } from '../../../../helper/configs'
import SelectPartOfTree from '../../../commonInterface/selectPartOfTree'
import { getJSONFromNodes } from '../Data'
import FileSaver from 'file-saver'
import howToImport1 from '../../../../../assets/images/howToImport1.gif'
import howToImport2 from '../../../../../assets/images/howToImport2.gif'
import howToImport3 from '../../../../../assets/images/howToImport3.gif'

function ExportAtSharingAddOn () {
  const selectPartOfTreeRef = useRef(null)

  return (
    <div css={css`padding: 10px; overflow-x: hidden;`}>
      <span>Export</span>
      <SelectPartOfTree ref={selectPartOfTreeRef} popoverHeight={100} lazyData />
      <Button
        text='Download' icon='cloud-download' onClick={() => {
          const nodeDataArray = selectPartOfTreeRef.current.getSelectedNodeData()
          const blob = new Blob([getJSONFromNodes(nodeDataArray)], { type: 'application/json' })
          FileSaver.saveAs(blob, 'LearnObit_Export.json')
          selectPartOfTreeRef.current.clearSelectedNodeData()
        }}
      />
      <div>* Your edits on this page will be exported too</div>
      <br />
      <div css={css`text-align: center;`}><Popover {...OverlayProps} targetTagName={'div'} content={(
        <Card css={css`max-height: 500px; overflow: auto;`}>
          <div>Access LearnObit with your account</div>
          <br /><br />
          <img src={howToImport1} />
          <br />
          <div>Select <Button minimal icon={'cog'} /> in the side menu</div>
          <br /><br />
          <img src={howToImport2} />
          <br />
          <div>Open the 'Data' box and import the exported file</div>
          <br /><br />
          <img src={howToImport3} />
          <br />
          <div>Drag the imported node to your tree and drop it</div>
        </Card>
      )}>
        <Button minimal icon={'help'} text={'How to Import'} />
      </Popover></div>
    </div>
  )
}

const ExportAtSharingAddOnBoxClass = new BoxClass(ExportAtSharingAddOn, 'Export', null, 'sharing', { order: 4 })

export default ExportAtSharingAddOnBoxClass
